import { isPreviewEnv } from '@core/base/utils/environment';

type PersonalizationValue = string | number | null;

interface PersonalizationOptions {
  age?: PersonalizationValue
  functionAnswer?: PersonalizationValue
  activityAnswer?: PersonalizationValue
}

export const FUNCTION_QUESTION_IDS = ['9', '105', '201'];
export const ACTIVITY_QUESTION_IDS = ['28', '127', '225'];

export function getQuizAnswerQueryKey(questionId: string | number): string {
  return `q${questionId}`;
}

const AGE_ID_POINTS: Record<string, number> = {
  1: 2,
  2: 1,
  3: 1,
  4: 0,
};

function answerPoints(answer: number): number {
  if (answer <= 2) return 0;
  if (answer === 3) return 1;
  return 2;
}

function agePoints(age?: PersonalizationValue): number | null {
  return AGE_ID_POINTS[String(age ?? '').trim()] ?? null;
}

function startLevelFromScore(score: number): number {
  if (score <= 3) return 1;
  if (score <= 4) return 2;
  if (score <= 6) return 3;
  return 4;
}

export function calculateStartLevel({
  age,
  functionAnswer,
  activityAnswer,
}: PersonalizationOptions): number | undefined {
  const { ENVIRONMENT } = useRuntimeConfig().public;
  const functionScoreAnswer = Number(functionAnswer);
  const activityScoreAnswer = Number(activityAnswer);
  const ageScore = agePoints(age);

  if (!functionScoreAnswer || !activityScoreAnswer || ageScore === null) {
    return undefined;
  }

  const functionPoints = answerPoints(functionScoreAnswer);
  const activityPoints = answerPoints(activityScoreAnswer);
  const score = (functionPoints * 2) + activityPoints + ageScore;
  const startLevel = startLevelFromScore(score);

  if (isPreviewEnv(ENVIRONMENT)) {
    // eslint-disable-next-line no-console
    console.info('[personalization] start level calculated', {
      answers: {
        functionAnswer: functionScoreAnswer,
        activityAnswer: activityScoreAnswer,
        age,
      },
      points: {
        functionPoints,
        activityPoints,
        agePoints: ageScore,
      },
      formula: 'score = (functionPoints * 2) + activityPoints + agePoints',
      score,
      startLevel,
    });
  }

  return startLevel;
}
